import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// 1. Import your existing Login/Register components
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import "./../Styles/cart.css";
import { API, UPLOADS } from "./../../config/api";
export default function Cart() {
  const navigate = useNavigate();
  const [cartData, setCartData] = useState([]);
  const [user, setUser] = useState(null);

  // 2. Add the same states used in your Navbar
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  /* ================= LOAD CART ================= */
  useEffect(() => {
    const loadUser = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      setUser(loginUser);

      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
        setCartData(saved);
      }
    };

    loadUser();

    // Listen for login/logout events just like Navbar does
    window.addEventListener("userLogin", loadUser);
    window.addEventListener("userLogout", loadUser);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", loadUser);
    };
  }, []);

  /* ================= REMOVE LOGIC ================= */
  /* ================= REMOVE LOGIC ================= */
  const removeItem = (id) => {
    const updated = cartData.filter((item) => item.id !== id);
    setCartData(updated);
    if (user) {
      localStorage.setItem(`cart_${user.id}`, JSON.stringify(updated));
      // TRIGGER NAVBAR UPDATE
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };

  const removeAll = () => {
    setCartData([]);
    if (user) {
      localStorage.setItem(`cart_${user.id}`, JSON.stringify([]));
      // TRIGGER NAVBAR UPDATE
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };
  /* ================= SEND ORDER ================= */
  const handleSendOrder = async () => {
    if (!user) {
      setShowLogin(true); // Open the popup if not logged in
      return;
    }

    if (cartData.length === 0) {
      alert("Your cart is empty!");
      return;
    }

    const orderPayload = {
      user_id: user.id,
      items: cartData,
      total_amount: total,
    };

    try {
      const res = await fetch(API.PLACE_ORDER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderPayload),
      });

      const data = await res.json();
      if (data.status) {
        alert("Order placed successfully!");
        removeAll();
        navigate("/myorders");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const total = cartData.reduce(
    (sum, item) => sum + Number(item.price || 0),
    0,
  );

  /* ================= RENDER PLACEHOLDER IF NOT LOGGED IN ================= */
  if (!user) {
    return (
      <div className="container text-center mt-5 py-5 border rounded bg-light shadow-sm">
        <i className="bi bi-cart-x fs-1 text-muted"></i>
        <h4 className="mt-3 fw-bold">Please Login to View Your Cart</h4>
        <p className="text-muted">
          You need to be logged in to manage your items and place orders.
        </p>

        {/* Trigger Pop-up */}
        <button
          className="btn btn-primary px-5 py-2 mt-2 fw-bold"
          onClick={() => setShowLogin(true)}
        >
          Login Now
        </button>

        {/* 3. Include the Pop-up components at the bottom */}
        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
            setShowRegister(true);
          }}
        />
        <Register
          isOpen={showRegister}
          onClose={() => setShowRegister(false)}
          openLogin={() => {
            setShowRegister(false);
            setShowLogin(true);
          }}
        />
      </div>
    );
  }

  /* ================= MOVE TO WISHLIST ================= */

  const moveToWishlist = (item) => {
    let wishlist =
      JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];

    const already = wishlist.find(
      (w) => w.id === item.id && w.type === "design",
    );

    if (!already) {
      wishlist.push({
        ...item,
        type: "design",
      });

      localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(wishlist));
    }

    removeItem(item.id);
  };

  /* ================= TOTAL ================= */

  return (
    <div className="cart-page container-fluid">
      <div className="row">
        {/* LEFT SIDE */}

        <div className="col-lg-9">
          <div className="cart-header">
            <div className="cart-left">
              <span>No</span>
              <span>Design ({cartData.length})</span>
            </div>

            <div className="cart-right">
              <span>Total Rs. {total}</span>

              <button className="remove-all" onClick={removeAll}>
                REMOVE ALL
              </button>
            </div>
          </div>

          {/* CART ITEMS */}

          <div className="cart-grid">
            {cartData.map((item, index) => (
              <div className="cart-item" key={item.id}>
                <div className="item-no">{index + 1}</div>

                <div className="cart-img-box">
                  <img
                    src={`${UPLOADS.DESIGN_IMAGE}${item.jpeg_file}`}
                    className="cart-img"
                    alt=""
                  />
                </div>

                <div className="cart-details">
                  <p>Code : {item.design_code}</p>
                  <p>Area : {item.area}</p>
                  <p>Stitch : {item.stitch}</p>
                  <p>Colour : {item.color}</p>
                </div>

                <div className="cart-price">Rs. {item.price || 0}</div>

                <div className="cart-icons">
                  <button
                    className="icon-btn"
                    onClick={() =>
                      navigate(`/designe-details/${item.id}`, { state: item })
                    }
                  >
                    <i className="bi bi-eye"></i>
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => moveToWishlist(item)}
                  >
                    <i className="bi bi-heart"></i>
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => removeItem(item.id)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button
            className="continue-btn"
            onClick={() => navigate("/designes")}
          >
            Continue Shopping
          </button>
        </div>

        {/* RIGHT SIDE */}

        <div className="col-lg-3">
          <div className="order-summary">
            <h4>ORDER SUMMARY</h4>

            <div className="summary-row">
              <span>{cartData.length} DESIGN IN CART</span>
            </div>

            <div className="summary-row">
              <span>Total Order</span>
              <span>Rs. {total}</span>
            </div>

            <button className="send-order" onClick={handleSendOrder}>
              SEND ORDER
            </button>
          </div>

          <div className="ads-section">
            <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
              <h5 className="ads-title">Sponsored</h5>

              <div className="ad-card mt-3">
                <div className="ad-placeholder">
                  <p className="small text-muted">Your Ad Here</p>
                </div>

                <p className="small mt-2">Premium Threads Sale!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
